import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home'

Vue.use(VueRouter)

const routes = [{
    path: '/home',
    name: 'home',
    component: () => import('../views/home')
  },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('../views/case')
  }, {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact')
  }, {
    path: '/service',
    name: 'service',
    component: () => import('../views/service')
  }
]

const router = new VueRouter({
  routes
})

export default router
